import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

import { Lock, MoreVertical, Pencil, Trash2 } from "lucide-react";
import { Dialog, DialogTrigger } from "@/components/ui/dialog";
import React from "react";
import { useToast } from "@/components/ui/use-toast";
import { CounterData } from "@/types/pos/counter";
import { ErrorType } from "@/types";
import warning from "@/assets/warning.svg";
import {
  useDeleteCounterMutation,
  useUpdateCountersMutation,
} from "@/services/counterApi";
import { Toast } from "@/components/ui/toast";
export function DataTableRowActions({
  data,
  refetch,
  handleEdit,
  access,
}: {
  data: CounterData;
  refetch: () => void;
  handleEdit: (data: CounterData) => void;
  access: string;
}) {
  const [isdelete, setIsDelete] = React.useState(false);
  const { toast } = useToast();
  const [assignCounter, result] = useUpdateCountersMutation();

  const [deleteCounter] = useDeleteCounterMutation();

  const deleteRow = async () => {
    try {
      const resp = await deleteCounter(data?.id as number).unwrap();
      if (resp) {
        refetch();
        toast({
          variant: "success",
          title: "Counter Deleted Successfully",
        });
      }
      return;
    } catch (error) {
      console.error("Error", { error });
      if (error && typeof error === "object" && "data" in error) {
        const typedError = error as ErrorType;
        toast({
          variant: "destructive",
          title: "Error in form Submission",
          description: `${typedError.data?.detail || typedError.data?.message}`,
        });
      } else {
        toast({
          variant: "destructive",
          title: "Error in form Submission",
          description: `Something Went Wrong.`,
        });
      }
    }
  };

  const closeCounter = async () => {
    try {
      const payload = {
        id: data?.id,
        is_open: false,
      };

      const resp = await assignCounter(payload).unwrap();
      if (resp) {
        toast({
          variant: "success",
          title: "Counter Closed Successfully",
        });
        await refetch();
      }

    } catch (error) {
      console.error("Error assigning counter:", error);
    }
  };

  return (
    <>
      <Dialog>
        <DropdownMenu>
          <DropdownMenuTrigger asChild onClick={(e) => e.stopPropagation()}>
            <Button
              variant="ghost"
              className="flex h-8 w-8 p-0 data-[state=open]:bg-muted"
            >
              <MoreVertical className="h-4 w-4" />
              <span className="sr-only">Open menu</span>
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="" onClick={(e) => e.stopPropagation()}>
            <DialogTrigger asChild>
              <DropdownMenuItem onClick={(e) => {
                e.stopPropagation();
                handleEdit(data)
              }}>
                <Pencil className="mr-2 h-4 w-4" />
                Edit
              </DropdownMenuItem>
            </DialogTrigger>
            {access == "full_access" && (
              <DropdownMenuItem onClick={(e) => {
                e.stopPropagation();
                if (data.staff_id !== null) {
                  toast({
                    variant: "destructive",
                    title: "Cannot Delete Counter",
                    description: "Counter is assigned to a cashier. Please unassign the cashier before deleting.",
                  });
                  return;
                }
                setIsDelete(true)
              }}>
                <Trash2 className="mr-2 h-4 w-4" />
                Delete
              </DropdownMenuItem>
            )}
            {access == "full_access" && data.is_open && (
              <DropdownMenuItem onClick={closeCounter} className="text-nowrap">
                <Lock className="mr-2 h-4 w-4" />
                Close Counter
              </DropdownMenuItem>
            )}
          </DropdownMenuContent>
        </DropdownMenu>
      </Dialog>
      {isdelete && (
        <AlertDialog open={isdelete} onOpenChange={setIsDelete}>
          <AlertDialogContent onClick={(e) => e.stopPropagation()}>
            <AlertDialogHeader>
              <AlertDialogDescription>
                <div className="flex flex-col items-center  justify-center gap-4">
                  <img src={warning} alt="warning" className="w-18 h-18" />
                  <AlertDialogTitle className="text-xl font-semibold w-80 text-center">
                    Are you sure you want to delete this counter? This action
                    cannot be undone.
                  </AlertDialogTitle>
                </div>
                <div className="w-full flex justify-between items-center gap-3 mt-4">
                  <AlertDialogCancel
                    onClick={(e) => {
                      e.stopPropagation();
                      setIsDelete(false)
                    }}
                    className="w-full border border-primary font-semibold"
                  >
                    <i className="fa fa-xmark text-base px-1 "></i>
                    Cancel
                  </AlertDialogCancel>
                  <AlertDialogAction
                    onClick={(e) => {
                      e.stopPropagation();
                      deleteRow()
                    }}
                    className="w-full bg-primary !text-black font-semibold"
                  >
                    <i className="fa-regular fa-floppy-disk text-base px-1 "></i>
                    Delete
                  </AlertDialogAction>
                </div>
              </AlertDialogDescription>
            </AlertDialogHeader>
          </AlertDialogContent>
        </AlertDialog >
      )
      }
    </>
  );
}
